import $ from 'jquery'
import Backbone from '@polleverywhere/backbone'

/**
 * Participant / presenter relationship model used to determine if a
 * relationship already exists, udpate or a create a new one.
 */
export default class PresenterRelationship extends Backbone.Model {
  get urlRoot () {
    return '/api/participant_presenter_relationships'
  }

  fetch (options) {
    if (options == null) { options = {} }
    options.url = `/api/participants/${this.get('participant_id')}/presenters/${this.get('presenter_id')}/relationship`
    return super.fetch(options)
  }

  hasNullScreenname () {
    // NOTE: Check specifically for null, not undefined or ""; but null!
    return this.isNew() || (this.get('screen_name') === null)
  }

  save (attributes, options) {
    return $.Deferred(dfd => {
      super.save(attributes, options)
        .fail(xhr => {
          if (xhr.status === 409) {
            const { error } = xhr.responseJSON
            if (error.detail.id) {
              this.set({ id: error.detail.id })
              return this.save(attributes, options)
                .fail(xhr => dfd.reject(xhr, 'Failed after retrying to save relationship')).then(dfd.resolve)
            } else {
              return dfd.reject(xhr, 'Conflict while saving relationship')
            }
          } else {
            return dfd.reject(xhr, 'Failed to update/create relationship')
          }
        }).then(dfd.resolve)
    })
  }
}
